import { render, staticRenderFns } from "./DepotAddModifyTyre.vue?vue&type=template&id=395420f6&scoped=true"
import script from "./DepotAddModifyTyre.vue?vue&type=script&lang=js"
export * from "./DepotAddModifyTyre.vue?vue&type=script&lang=js"
import style0 from "./DepotAddModifyTyre.vue?vue&type=style&index=0&id=395420f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395420f6",
  null
  
)

export default component.exports